import { cn } from "@/lib/cn";
import { CONTACT_CHANNELS } from "@/lib/contactChannels";

// The footer icon row. Real destinations live in lib/contactChannels so the
// /contact page (the textual fallback) stays in sync. The mail icon is a raw
// mailto: which silently does nothing on machines with no mail handler — the
// /contact page is the reliable, copy-pasteable path, one click away.
export function SocialLinks({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      {CONTACT_CHANNELS.map(({ key, label, href, Icon, external }) => (
        <a
          key={key}
          href={href}
          {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
          aria-label={label}
          className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/5 text-muted-foreground transition-colors duration-300 hover:bg-white/10 hover:text-foreground"
        >
          <Icon className="h-[18px] w-[18px]" />
        </a>
      ))}
    </div>
  );
}
